/*
 * Uniform mobile peek for every <swiper-slider>.
 *
 * The theme's slider component lives in an obfuscated base.js, and when
 * `data-slider-partial-slides-mobile="true"` it hardcodes slidesPerView: 1.2
 * at the 0px breakpoint. The brief calls for 1.5 — one full card plus a
 * clear half of the next — so rather than fork the obfuscated bundle we
 * adjust the Swiper instance after it initialises.
 *
 * Below the 800px tablet tier the peek is tuned per tier: small phones get a
 * modest 1.2 (a full card plus a sliver) because a half card leaves too little
 * of the first one, while larger phones get 1.5. Tablet and desktop keep the
 * values the section's own settings produced.
 */
(function () {
  // theme breakpoint tiers are 0 / 500 / 800 / 1200 / 1600
  var MOBILE_MAX_WIDTH = 800;   // first non-mobile tier
  var SMALL_PHONE_MAX = 500;    // below this, use the gentler peek
  var PEEK_SMALL = 1.2;
  var PEEK_LARGE = 1.5;

  function peekFor(bp) {
    return bp < SMALL_PHONE_MAX ? PEEK_SMALL : PEEK_LARGE;
  }
  var MAX_TRIES = 40; // ~4s at 100ms — the bundle is deferred

  function tune(el) {
    var sw = el.swiper;
    if (!sw || !sw.params) return false;
    if (el.dataset.sliderPartialSlidesMobile !== 'true') return true;
    if (el.dataset.partialMobileTuned === '1') return true;

    var bps = sw.params.breakpoints;
    if (!bps) return true;

    // The theme's tiers are 0 / 500 / 800 / 1200 / 1600. Everything below the
    // 800 tablet tier counts as mobile — patching only the 0 tier left phones
    // in the 500-799 range showing whole slides.
    var touched = false;
    Object.keys(bps).forEach(function (k) {
      var bp = Number(k);
      if (bp >= MOBILE_MAX_WIDTH) return;
      bps[k].slidesPerView = peekFor(bp);
      touched = true;
    });
    if (!touched) return true;

    el.dataset.partialMobileTuned = '1';

    // re-apply immediately if one of those tiers is currently active
    var w = window.innerWidth;
    if (w < MOBILE_MAX_WIDTH) {
      sw.params.slidesPerView = peekFor(w < SMALL_PHONE_MAX ? 0 : SMALL_PHONE_MAX);
      sw.update();
    }
    return true;
  }

  function sweep() {
    var els = document.querySelectorAll('swiper-slider, .swiper-slider');
    var pending = false;
    for (var i = 0; i < els.length; i++) {
      if (!tune(els[i])) pending = true;
    }
    return !pending;
  }

  function run() {
    var tries = 0;
    (function poll() {
      if (sweep() || ++tries >= MAX_TRIES) return;
      setTimeout(poll, 100);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // theme editor re-renders a section without a full page load
  document.addEventListener('shopify:section:load', run);
})();
